import { rgbAlpha } from "@/utils/theme";
import { ThemeColorPresets } from "#/enum";

export const presetsColors = {
	[ThemeColorPresets.Default]: {
		lighter: "#FFF9F1",
		light: "#FFE1B6",
		default: "#FFA21A",
		dark: "#E59217",
		darker: "#73490C",
	},
	// [ThemeColorPresets.Cyan]: {
	// 	lighter: "#CCF4FE",
	// 	light: "#68CDF9",
	// 	default: "#078DEE",
	// 	dark: "#0351AB",
	// 	darker: "#012972",
	// },
	// [ThemeColorPresets.Purple]: {
	// 	lighter: "#EBD6FD",
	// 	light: "#B985F4",
	// 	default: "#7635DC",
	// 	dark: "#431A9E",
	// 	darker: "#200A69",
	// },
	// [ThemeColorPresets.Blue]: {
	// 	lighter: "#D1E9FC",
	// 	light: "#76B0F1",
	// 	default: "#2065D1",
	// 	dark: "#103996",
	// 	darker: "#061B64",
	// },
	// [ThemeColorPresets.Orange]: {
	// 	lighter: "#FEF4D4",
	// 	light: "#FED680",
	// 	default: "#FDA92D",
	// 	dark: "#B66816",
	// 	darker: "#793908",
	// },
	// [ThemeColorPresets.Red]: {
	// 	lighter: "#FFE3D5",
	// 	light: "#FF9882",
	// 	default: "#FF3030",
	// 	dark: "#B71833",
	// 	darker: "#7A0930",
	// },
};

/**
 * We recommend picking colors with these values for [Eva Color Design](https://colors.eva.design/):
 *  + lighter : 100
 *  + light : 300
 *  + main : 500
 *  + dark : 700
 *  + darker : 900
 */
export const paletteColors = {
	primary: presetsColors[ThemeColorPresets.Default],
	success: {
		lighter: "#ECFDF3",
		light: "#A9EFC5",
		default: "#17B26A",
		dark: "#079455",
		darker: "#074D31",
	},
	warning: {
		lighter: "#FFFAEB",
		light: "#FEDF89",
		default: "#F6B417",
		dark: "#DC6803",
		darker: "#7A2E0E",
	},
	error: {
		lighter: "#FEF3F2",
		light: "#FECDCA",
		default: "#F04438",
		dark: "#D92D20",
		darker: "#7A271A",
	},
	info: {
		lighter: "#EFF8FF",
		light: "#B2DDFF",
		default: "#2E90FA",
		dark: "#1570EF",
		darker: "#194185",
	},
	//
	gray: {
		"100": "#F9FAFB",
		"200": "#F8F9FA", // ui 模块背景/表头
		"300": "#F3F4F5", // ui 大背景
		"400": "#EEEFF0", // ui 线条
		"500": "#DCDEE1", // ui 边框/线条
		"600": "#BCBDC0", // ui 禁用
		"700": "#898B8F", // ui 三级
		"800": "#565960", // ui 二级
		"900": "#252931", // ui 一级
	},
	// gray: {
	// 	"100": "#F9FAFB",
	// 	"200": "#F4F6F8",
	// 	"300": "#DFE3E8",
	// 	"400": "#C4CDD5",
	// 	"500": "#919EAB",
	// 	"600": "#637381",
	// 	"700": "#454F5B",
	// 	"800": "#1C252E",
	// 	"900": "#141A21",
	// },
};

export const commonColors = {
	white: "#FFFFFF",
	black: "#09090B",
};

export const actionColors = {
	hover: rgbAlpha(paletteColors.gray[500], 0.2),
	selected: rgbAlpha(paletteColors.gray[500], 0.2),
	focus: rgbAlpha(paletteColors.gray[500], 0.2),
	disabled: rgbAlpha(paletteColors.gray[500], 0.48),
	active: rgbAlpha(paletteColors.gray[500], 1),
};

export const lightColorTokens = {
	palette: paletteColors,
	common: commonColors,
	action: actionColors,
	text: {
		primary: paletteColors.gray[900],
		secondary: paletteColors.gray[800],
		disabled: paletteColors.gray[600],
	},
	background: {
		default: commonColors.white,
		paper: commonColors.white,
		neutral: paletteColors.gray[200],
	},
};

export const darkColorTokens = {
	palette: paletteColors,
	common: commonColors,
	action: actionColors,
	text: {
		primary: commonColors.white,
		secondary: paletteColors.gray[500],
		disabled: paletteColors.gray[600],
	},
	background: {
		default: commonColors.black,
		paper: commonColors.black,
		neutral: "#27272A",
	},
};
